export default function (instance) {
  return {
    get(newsId) {
      return instance.get(`/api/v2/news/${newsId}`)
    }
  }
}